var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SceneContainer',[_c('div',{ref:"configuratorContainer",staticClass:"configurator"})])}
var staticRenderFns = []

export { render, staticRenderFns }